import { mapActions, mapGetters } from 'vuex';

const _ = require('lodash')

export default {
    props: ['orderData'], 
    data() {
        return {
            typeShipmentPlace:false,
            checkedList: [],
            cityQuery: '',
            showCitySearchInput: false,
            counterpartySenderList: [],
            dbCounterpartiesList: [],
            form: {
                api_type: 'new_post',
                order_id: 0,
                type: 'WarehouseWarehouse',
                firstname: "",
                lastname: "",
                middlename: "",
                cabinet_id: 0,
                counterparty_id: '',
                np_counterparty_id: null,
                sender_name: '', 
                city_agent: '',
                warehouses_agent: '',
                payer_name: '',
                bayer_areas: '',
                street_guid: '',
                bayer_house: '',
                bayer_kv: '',
                phone: '',
                payer: 'Recipient',
                payer_back: 'Recipient',
                payment_form: 0,
                shipping_date: this.$moment(),
                back_delivery: true,
                special_cargo: false,
                after_payment_on_goods_cost: false,
                delivery_object: 0,
                description_object: 0,
                back_delivery_method: 'Money',
                description: '',
                dop: '',
                cost: 0, 
                city_guid: '',
                temp_city_guid: {},
                warehouse_guid: '',
                seats: [],
                address:'',
                house:'',
                flat:'',
                city:'',
            },
            addressList:[],
            deliveryObject: [
                {
                    id: 0,
                    title: 'Посылка'
                }
            ],
            descriptionObject: [
                {
                    id: 0,
                    title: 'Постельное белье'
                }
            ],
            shipmentDate: [
                {
                    id: this.$moment(),
                    title: 'Сегодня (' + this.$moment().format('DD.MM.YYYY') + ')'
                },
                {
                    id: this.$moment().add(1, 'days'),
                    title: 'Завтра (' + this.$moment().add(1, 'days').format('DD.MM.YYYY') + ')',
                },
                {
                    id: this.$moment().add(2, 'days'),
                    title: 'Послезавтра (' + this.$moment().add(2, 'days').format('DD.MM.YYYY') + ')',
                },
            ],
            backShipment: [
                {
                    id: 'Money',
                    title: 'Денежный перевод'
                },
            ],
            payer: [
                {
                    id: 'Recipient',
                    title: 'Получатель'
                },
                {
                    id: 'Sender',
                    title: 'Отправитель'
                },
            ],
            paymentForm: [
                {
                    id: 0,
                    title: 'Наличными'
                },
                {
                    id: 1,
                    title: 'Безналичными'
                },
            ],
            type: [
                {
                    title: 'Отделение-Отделение',
                    id: 'WarehouseWarehouse',
                },
                {
                    title: 'Отделение-Адрес',
                    id: 'WarehouseDoors',
                },
                {
                    title: 'Адрес-Отделение',
                    id: 'DoorsWarehouse',
                },
                {
                    title: 'Адрес-Адрес',
                    id: 'DoorsDoors',
                },
            ],
            cabinet: [
                {
                    title: 'Черешенька',
                    id: 0,
                }
            ],
            npAreasList: [],
            npCityList: [],
            npCityListSender: [],
            npWarehousesList: [],
            npWarehousesListClient: [],
            npCityListClient: [],
            productCategoriesList: [],
            address:[],
            addressSender:null,
            allList:{
                width:0,
                height:0,
                length:0,
                weight:0,
                count:1,
                weightValue:0,
                volume:0,
            },
            allValue: 0,
            activeHide: false,
        }
    },
    computed: {
        ...mapGetters({
            npCity: 'plugins/npCity',
            options: 'config/options',
            npAreas: 'plugins/npAreas',
            npWarehouses: 'plugins/npWarehouses',
            productCategories: 'catalog/productCategories',
            counterpartyAddress: 'plugins/counterpartyAddress',
            counterpartySender: 'plugins/counterpartySender',
            npCounterparties: 'npAutomation/npCounterparties',
        }),
        isBackDeliveryDisabled() {
            return this.form.after_payment_on_goods_cost === true;
        },
        isPaymentFormDisabled() {
            return this.form.after_payment_on_goods_cost === true;
        },
    },
    watch: {
        options(e) { 
            if (e) {
                this.loadCounterpartiesFromDb();
                // Only set defaults from global options if no counterparty is selected
                // Counterparty selection will override these values with counterparty-specific data
                if (!this.form.counterparty_id && !this.form.np_counterparty_id) {
                    this.form.sender_name = e.models.np_firstname + ' ' + e.models.np_lastname + ' ' + e.models.np_middlename;
                    this.form.sender_name += ' (' + e.models.np_phone + ')';
                    this.getNpCityAction(e.models.np_area, true);
                    this.getNpWarehouseAction(e.models.np_city, true);
                    this.form.city_agent = e.models.np_city
                    this.form.warehouses_agent = e.models.np_warehouse
                }
            }

        },
        npCounterparties(data) {
            if (data && Array.isArray(data)) {
                this.dbCounterpartiesList = data
                    .map(item => {
                        const ref = item.ref;
                        if (!this.isValidUuid(ref)) {
                            return null;
                        }
                        const afterPayment = this.normalizeAfterPaymentFlag(item.after_payment_on_goods_cost);
                        // Build contact name from ПІБ
                        const contactName = [item.first_name, item.last_name].filter(Boolean).join(' ') || null;
                        // Build address from city_name + warehouse_name
                        const address = [item.city_name, item.warehouse_name].filter(Boolean).join(', ') || item.address || null;

                        return {
                            id: String(ref),
                            title: item.name,
                            phone: item.phone,
                            contact_name: contactName,
                            address: address,
                            first_name: item.first_name,
                            middle_name: item.middle_name,
                            last_name: item.last_name,
                            area_name: item.area_name,
                            city_name: item.city_name,
                            warehouse_name: item.warehouse_name,
                            is_default: item.is_default,
                            after_payment_on_goods_cost: afterPayment,
                            _raw: item,
                        };
                    })
                    .filter(Boolean);
                if (this.dbCounterpartiesList.length) {
                    this.counterpartySenderList = [...this.dbCounterpartiesList];
                    this.ensureCounterpartySelection();
                } else {
                    this.counterpartySenderList = [];
                    this.loadCounterpartySendersFromApi();
                }
            }
        },
        counterpartySender(e) {
            // Fallback: if no DB counterparties, use API ones
            if (!this.dbCounterpartiesList.length) {
                const modelsData = e && (e.models || e.data || e);
                const options = this.normalizeCounterpartyOptions(modelsData);
                if (options.length) {
                    this.counterpartySenderList = options;
                    this.ensureCounterpartySelection();
                }
            }
        },
        counterpartyAddress(e){
            this.address = [];
            let key;
            for(key in e.models){
                this.address.push({
                    id: key,
                    title: e.models[key],
                })
            }
            this.addressSender = this.address[0].id;
        },
        productCategories(e) {
            if (e) {
                e.data.map(item => {
                    this.productCategoriesList.push({
                        id: item.id,
                        title: item.title,
                        default_width: item.default_width,
                        default_height: item.default_height,
                        default_length: item.default_length,
                        default_weight: item.default_weight,
                    })
                    if (item.children) {
                        item.children.map(itemChild => {
                            this.productCategoriesList.push({
                                id: itemChild.id,
                                title: itemChild.title,
                                default_width: itemChild.default_width,
                                default_height: itemChild.default_height,
                                default_length: itemChild.default_length,
                                default_weight: itemChild.default_weight,
                            })
                        })
                    }
                })
            }
            this.getProductSizes();
            this.getAllProducts();
        },
    },
    created() { 
        this.getProductCategories();
        this.getOptions();
        // this.getNpAreas().then(res => {
        //     if (res.status) {
        //         let key;
        //         for (key in res.data.models) {
        //             this.npAreasList.push({
        //                 id: key,
        //                 title: res.data.models[key]
        //             })
        //         }
        //     }
        // });
        this.getOrderInfo();
        this.getAllProducts();
    },
    methods: {
        normalizeAfterPaymentFlag(value) {
            if (value === true || value === false) {
                return value;
            }
            if (value === 1 || value === '1') {
                return true;
            }
            if (value === 0 || value === '0') {
                return false;
            }
            if (typeof value === 'string') {
                const normalized = value.trim().toLowerCase();
                if (normalized === 'true') {
                    return true;
                }
                if (normalized === 'false') {
                    return false;
                }
            }
            return Boolean(value);
        },
        normalizePaymentFlags() {
            if (this.form.after_payment_on_goods_cost) {
                this.form.back_delivery = false;
                return;
            }
            if (this.form.back_delivery) {
                this.form.after_payment_on_goods_cost = false;
            }
        },
        changeGoodsCost(){
            this.normalizePaymentFlags();
        },
        changeBackDelivery(){
            this.normalizePaymentFlags();
        },
        getAllProducts(){
            this.allList = {
                width:0,
                height:0,
                length:0,
                weight:0,
                count:1,
                weightValue:0,
                volume:0,
            }
            this.orderData.products.map(item=>{
                if(+this.allList.width < +item.product.default_width){
                    this.allList.width = item.product.default_width ? Number(item.product.default_width) : 0;
                }
                if(+this.allList.length < +item.product.default_length){
                    this.allList.length = +item.product.default_length;
                }

                this.allList.height += item.product.default_height ? Number(item.product.default_height) : 0;
                this.allList.weight += item.product.default_weight ? Number(item.product.default_weight) : 0;
            })
            this.getAllValue();
        },
        getAllValue(){
            this.allList.volume = Number((this.allList.height * this.allList.length * this.allList.width) / 1000000).toFixed(4)
            this.allList.weightValue = Number((this.allList.height * this.allList.length * this.allList.width) / 4000).toFixed(4)
        },
        checkAllItems(){
            if(this.checkedList.length >= 2){
                let newProduct = {
                    title:'',
                    price:0,
                    quantity:1,
                    id:0,
                    product:{
                        default_width:0,
                        default_length:0,
                        default_height:0,
                        default_weight:0,
                    }
                }

                this.checkedList.map(item=>{
                    if(+item.product.default_width >= +newProduct.product.default_width){
                        newProduct.product.default_width = item.product.default_width;
                    }
                    if(+item.product.default_length >= +newProduct.product.default_length){
                        newProduct.product.default_length = +item.product.default_length;
                    }
                    newProduct.product.default_height += +item.product.default_height;
                    newProduct.product.default_weight += +item.product.default_weight;
                    newProduct.title += item.title + '; ';
                    newProduct.price += +item.price * +item.quantity;
                    newProduct.id += item.id;
                    let index = this.orderData.products.indexOf(item);
                    this.orderData.products.splice(index, 1);
                })
                this.orderData.products.push(newProduct);
            }else{
                this.$toasted.show('Необходимо выбрать больше одной единицы для объединения',{
                    duration: 3000
                })
            }
        },
        sendOrderNewPost() {
            
            if(this.typeShipmentPlace){
                this.orderData.products.map(item=>{
                    this.form.seats.push({
                        weight:item.product.default_weight ?  item.product.default_weight : 0.1,
                        volume: this.getValue(item) ? this.getValue(item) : 0.0004,

                    })
                })
            }else{
                this.form.seats.push({
                    weight:this.allList.weight ? this.allList.weight : 0.1,
                    volume: this.allList.volume ? this.allList.volume : 0.0004 ,

                })
            }

            console.log('this.form.temp_city_guid 01 - ', this.form.temp_city_guid) 

            if(this.form.type === 'WarehouseDoors' || this.form.type === 'DoorsDoors'){
                if(this.form.address){
                    this.form.city = this.form.temp_city_guid.title ? this.form.temp_city_guid.title : '';
                    this.form.city_guid = this.form.temp_city_guid.id;
                    this.funcSendOrder();
                }else{
                    this.$toasted.error("Поле Улица обязательно для заплнения",{
                        duration : 3000,
                        position: 'top-center',
                    });
                }
            }else{
                this.form.city = this.form.temp_city_guid.title ? this.form.temp_city_guid.title : '';
                this.form.city_guid = this.form.temp_city_guid.id;
                this.funcSendOrder()
            }

        },
        funcSendOrder(){ 
            this.addOrderNewPost(this.form).then(res=>{
                if(res.status){
                    this.$emit('closePopup')
                    this.$toasted.success('ТТН успешно создан',{
                        duration : 3000
                    });
                }else {
                    if(res.data.errors){
                        let key;
                        for(key in res.data.errors){
                            this.$toasted.error(res.data.errors[key],{
                                duration : 3000
                            });
                        }
                    }else{
                        this.$toasted.error("Ошибка при создании ТТН",{
                            duration : 3000
                        });
                    }
                }
                this.showOrder(this.orderData.id)
            });

        },
        getProductSizes() {
            this.form.cost = 0;
            this.orderData.products.map(item => {
                const quantity = Number(item.quantity || 0) || 0;
                const productPrice = Number(item.price || 0) || 0;
                const airPrice = Number(item.price_air || 0) || 0;

                // Total declared cost should include product price + air delivery surcharge (if present)
                this.form.cost += (productPrice + airPrice) * quantity;
                this.productCategoriesList.map(itemCategory => {
                    if (item.product.category_id === itemCategory.id) {
                        item.product = {
                            id: item.product.id,
                            category_id: item.product.category_id,
                            default_width: itemCategory.default_width ? itemCategory.default_width : 0,
                            default_height: itemCategory.default_height ? itemCategory.default_height : 0,
                            default_length: itemCategory.default_length ? itemCategory.default_length : 0,
                            default_weight: itemCategory.default_weight ? itemCategory.default_weight : 0,
                            whole_width: this.getValue(item),
                        }
                    }
                })
            });
            this.form.order_id = this.orderData.id
            this.form.cost = Number(this.form.cost).toFixed(2);
        },
        getValue(item){
            this.allValue = 0;
            const result = (item.product.default_height * item.product.default_length * item.product.default_width) / 1000000
            this.allValue = Number(result).toFixed(4);
            return Number(result).toFixed(4);
        },
        changeSenderAreas() {
            // this.getNpCityAction(this.form.areas_agent, true)
            this.form.city_agent = null;
            this.form.warehouses_agent = null;
        },
        changeSenderCity() {
            this.getNpWarehouseAction(this.form.city_agent, true)
            this.form.warehouses_agent = null;
        },
        changeSenderAreasClient() {
            // this.getNpCityAction(this.form.area_guid, false)
            // this.form.temp_city_guid = null;
            this.form.warehouse_guid = null;
        },
        searchSenderCityClient: _.debounce(function(){
            if(this.cityQuery.length > 2){
                this.getNpCitySearch(this.cityQuery).then(res => {
                    this.npCityList = [];
                    let key;
                    for (key in res.data.models) {
                        this.npCityList.push({
                            id: key,
                            title: res.data.models[key]
                        })
                    } 
                    const elem = this.$refs.citySelect
                    elem.open = true
                    // elem.click();
                }) 
            }
        }, 1000),
        focusSearch(){ 
            this.showCitySearchInput = true;
            setTimeout(() => {
                this.$refs.inputSearch.focus();
            }, 50)
        },
        changeSenderCityClient(){
            console.log('this.form.temp_city_guid 01 - ', this.form.temp_city_guid)
            this.cityQuery = this.form.temp_city_guid.title
            this.getNpWarehouseAction(this.form.temp_city_guid.id, false)
            this.form.warehouse_guid = null;
        },
        getOrderInfo() {
            const checkName = this.orderData.customer_name.split(/\s+/g);
            if (checkName.length <= 1) {
                this.$toasted.error('Некорректно указаны ФИО получателя! <br><br> Минимум требуются: Фамилия, Имя и Отчество.', {
                    duration: 3000,
                    position: 'top-center',
                });
                this.$emit('closePopup')
            } else {
                this.form.firstname = checkName[0];
                this.form.lastname = checkName[1];
                this.form.middlename = checkName[2];
                this.form.payer_name = this.orderData.customer_name;
                this.form.phone = this.orderData.phone
            }
        },
        getNpCityAction() {
            this.getNpCity().then(res => {
                if (res.status) {
                    const npCityListSenderBoolean = Boolean(this.npCityListSender.length)
                    this.npCityList = [];
                    let key;
                    for (key in res.data.models) {
                        this.npCityList.push({
                            id: key,
                            title: res.data.models[key]
                        }) 
                        if(!npCityListSenderBoolean){
                            this.npCityListSender.push({
                                id: key,
                                title: res.data.models[key]
                            }) 
                        }
                    }
                } else if (res.status) {
                    this.npCityListClient = [];
                    let key;
                    for (key in res.data.models) {
                        this.npCityListClient.push({
                            id: key,
                            title: res.data.models[key]
                        })
                    }
                }
            })
        },
        getNpWarehouseAction(id, sender) {
            this.getNpWarehouses({'city_id': id}).then(res => {
                if (res.status && sender) {
                    this.npWarehousesList = [];
                    let key;
                    for (key in res.data.models) {
                        this.npWarehousesList.push({
                            id: key,
                            title: res.data.models[key]
                        })
                    }
                } else if (res.status && !sender) {
                    this.npWarehousesListClient = [];
                    let key;
                    for (key in res.data.models) {
                        this.npWarehousesListClient.push({
                            id: key,
                            title: res.data.models[key]
                        })
                    }
                }
            })
        },
        closePopup() {
            this.$emit('closePopup')
        },
        isValidUuid(value) {
            if (!value) {
                return false;
            }
            const normalized = String(value).trim();
            return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(normalized);
        },
        normalizeCounterpartyOptions(modelsData) {
            const options = [];
            if (!modelsData) {
                return options;
            }
            if (Array.isArray(modelsData)) {
                modelsData.forEach((item, index) => {
                    if (!item) {
                        return;
                    }
                    const id = item.id || item.ref || item.key || item.Ref || item.Reference || String(index);
                    if (!this.isValidUuid(id)) {
                        return;
                    }
                    options.push({
                        id: String(id),
                        title: String(item.name || item.title || item.value || item.Description || item.description || id),
                    });
                });
                return options;
            }
            if (typeof modelsData === 'object') {
                Object.keys(modelsData).forEach(key => {
                    if (!this.isValidUuid(key)) {
                        return;
                    }
                    options.push({
                        id: String(key),
                        title: String(modelsData[key] || key),
                    });
                });
            }
            return options;
        },
        ensureCounterpartySelection() {
            if (!this.counterpartySenderList.length) {
                return;
            }
            const selectedId = this.form.counterparty_id;
            if (selectedId && this.isValidUuid(selectedId)) {
                const exists = this.counterpartySenderList.find(c => c.id === selectedId);
                if (exists) {
                    return;
                }
            }
            // Priority 1: Use DB counterparty with is_default: true
            const dbDefaultCounterparty = this.dbCounterpartiesList.find(cp => cp.is_default === true);
            if (dbDefaultCounterparty && dbDefaultCounterparty.id) {
                this.form.counterparty_id = dbDefaultCounterparty.id;
                this.onCounterpartyChange(this.form.counterparty_id);
                return;
            }
            // Priority 2: Fallback to global option if no DB default exists
            const defaultId = this.options?.models?.np_counterparty_sender;
            const defaultOption = this.isValidUuid(defaultId)
                ? this.counterpartySenderList.find(c => c.id === String(defaultId))
                : null;
            // Priority 3: Use first available counterparty
            this.form.counterparty_id = defaultOption ? defaultOption.id : this.counterpartySenderList[0].id;
            this.onCounterpartyChange(this.form.counterparty_id);
        },
        loadCounterpartiesFromDb() {
            // Load counterparties from database
            this.getNpCounterparties().then(() => {
                this.$nextTick(() => {
                    // If no valid DB counterparties, fallback to API
                    if (!this.dbCounterpartiesList.length) {
                        this.loadCounterpartySendersFromApi();
                    }
                });
            }).catch(() => {
                // Fallback to API on error
                this.loadCounterpartySendersFromApi();
            });
        },
        loadCounterpartySendersFromApi() {
            // Require database counterparties - no fallback to global API key
            const errorMsg = 'Спочатку додайте контрагента в базу даних через налаштування Нової Пошти';
            if (this.$toasted) {
                this.$toasted.error(errorMsg, { duration: 5000 });
            }
            console.error('No database counterparties available. User must add counterparties to database first.');
            throw new Error(errorMsg);
        },
        onCounterpartyChange(counterpartyId) {
            if (!counterpartyId) {
                return;
            }
            if (!this.isValidUuid(counterpartyId)) {
                if (this.$toasted) {
                    this.$toasted.error('Некоректний ID контрагента. Синхронізуйте або виправте Ref.', { duration: 3000 });
                }
                return;
            }

            // Clear all sender fields first before populating with new counterparty data
            this.form.sender_name = '';
            this.form.city_agent = '';
            this.form.warehouses_agent = '';
            this.form.np_counterparty_id = null;
            this.form.after_payment_on_goods_cost = false;
            this.normalizePaymentFlags();
            this.npWarehousesList = [];
            this.address = [];
            this.addressSender = null;

            // Find selected counterparty in list and populate sender fields from its own data
            const selectedCp = this.counterpartySenderList.find(c => c.id === counterpartyId);
            
            // Save the database ID for the backend to use the correct API key
            this.form.np_counterparty_id = selectedCp?._raw?.id || null;
            if (selectedCp && selectedCp._raw) {
                const raw = selectedCp._raw;

                // Build sender name from counterparty's contact person ПІБ
                const contactName = [raw.first_name, raw.last_name, raw.middle_name].filter(Boolean).join(' ');
                if (contactName) {
                    this.form.sender_name = raw.phone ? `${contactName} (${raw.phone})` : contactName;
                } else {
                    // Fallback to counterparty name if no contact info
                    this.form.sender_name = raw.name || selectedCp.title || '';
                }

                // Load payment control setting from counterparty
                this.form.after_payment_on_goods_cost = this.normalizeAfterPaymentFlag(raw.after_payment_on_goods_cost);
                this.normalizePaymentFlags();

                // Set sender city and warehouse from this counterparty's data (only if available)
                if (raw.city_guid) {
                    this.form.city_agent = raw.city_guid;
                    // Load warehouses for this counterparty's city
                    this.getNpWarehouseAction(raw.city_guid, true);

                    // Set warehouse after warehouses are loaded (only if counterparty has warehouse_guid)
                    if (raw.warehouse_guid) {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.form.warehouses_agent = raw.warehouse_guid;
                            }, 500);
                        });
                    }
                }
            } else if (selectedCp) {
                // For counterparties loaded from API (without _raw), use basic info
                this.form.sender_name = selectedCp.title || '';
                if (selectedCp.after_payment_on_goods_cost !== undefined) {
                    this.form.after_payment_on_goods_cost = this.normalizeAfterPaymentFlag(selectedCp.after_payment_on_goods_cost);
                    this.normalizePaymentFlags();
                }
            }

            // Fetch counterparty address from API
            // Pass both NP ref (counterparty_id) and DB id (db_counterparty_id) so backend can use counterparty's own stored np_api_key
            const dbCounterpartyId = selectedCp?._raw?.id;
            if (dbCounterpartyId) {
                // For DB counterparties - pass NP ref + DB id, backend will use counterparty's own stored API key
                this.getCounterpartyAddress({ counterparty_id: counterpartyId, db_counterparty_id: dbCounterpartyId });
            } else {
                // Require database counterparty - no fallback to global API key
                const errorMsg = 'Виберіть контрагента з бази даних або додайте його через налаштування Нової Пошти';
                if (this.$toasted) {
                    this.$toasted.error(errorMsg, { duration: 5000 });
                }
                console.error('Counterparty not found in database:', counterpartyId);
                throw new Error(errorMsg);
            }
        },
        ...mapActions({
            getProductCategories: 'catalog/getProductCategories',
            getNpWarehouses: 'plugins/getNpWarehouses',
            getNpCitySearch: 'plugins/getNpCitySearch',
            getNpAreas: 'plugins/getNpAreas',
            getOptions: 'config/getOptions',
            getNpCity: 'plugins/getNpCity',
            addOrderNewPost: 'orders/addOrderNewPost',
            getCounterpartyAddress:'plugins/getCounterpartyAddress',
            getCounterpartySender:'plugins/getCounterpartySender',
            showOrder:'orders/showOrder',
            getNpCounterparties: 'npAutomation/getNpCounterparties',
        })
    }
}
